import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '../../../app/providers/useAuth';
import { createTask, type CreateTaskInput } from '../api/tasksApi';

// PARA-128 — создание задачи одним POST; инвалидирует ['tasks', userId] (AC-2).
export function useCreateTask() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTaskInput) => createTask(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['tasks', user?.id] });
    },
  });
}
